import LocalizedStrings from 'localized-strings';

interface ScheduledTransferSettingsSidebarLocales {
  confirmCta: string;
  deleteSettings: string;
  errors: {
    atLeastOneOccurrence: string;
    lastDueDateMustBeAfterNextDueDate: string;
    lastDueDateMustBeInTheFuture: string;
    nextDueDateMustBeInFuture: string;
  };
  frequency: string;
  amountAboveThreshold: string;
  lastDueDate: string;
  lastDueDateBasedOnOccurrences: string;
  nextDueDate: string;
  title: string;
}

export default new LocalizedStrings<ScheduledTransferSettingsSidebarLocales>({
  en: {
    amountAboveThreshold:
      'Transfers of {0} or more cannot be scheduled over multiple deadlines.',
    confirmCta: 'Confirm settings',
    deleteSettings: 'Delete settings',
    errors: {
      atLeastOneOccurrence: 'At least one occurrence is required',
      lastDueDateMustBeAfterNextDueDate:
        'Last due date must be after first due date.',
      lastDueDateMustBeInTheFuture:
        'The last due date can’t be today or in the past.',
      nextDueDateMustBeInFuture:
        'The next due date can’t be today or in the past.',
    },
    frequency: 'Frequency',
    lastDueDate: 'Last due date',
    lastDueDateBasedOnOccurrences: 'Last one: {0}',
    nextDueDate: 'Next due date',
    title: 'Scheduled transfer settings',
  },
  fr: {
    amountAboveThreshold:
      'Les virements à partir de {0} ne sont pas programmables sur plusieurs échéances.',
    confirmCta: 'Confirmer les paramètres',
    deleteSettings: 'Supprimer les paramètres',
    errors: {
      atLeastOneOccurrence: 'Au moins une occurrence est requise',
      lastDueDateMustBeAfterNextDueDate:
        'La date de dernière échéance doit être après la première échéance.',
      lastDueDateMustBeInTheFuture:
        'La date de dernière échéance ne peut pas être aujourd’hui ou être passée.',
      nextDueDateMustBeInFuture:
        'La date de première échéance ne peut pas être aujourd’hui ou être passée.',
    },
    frequency: 'Fréquence',
    lastDueDate: 'Dernière échéance',
    lastDueDateBasedOnOccurrences: 'Fin : {0}',
    nextDueDate: 'Première échéance',
    title: 'Paramètres du virement',
  },
} as const);
